{
  "title": "Inventaires",
  "subtitle": "Comptez ce qui est vraiment en rayon ; la validation corrige le stock pour le faire correspondre.",
  "status": {
    "draft": "Brouillon",
    "in_progress": "En cours",
    "review": "À vérifier",
    "validated": "Validé",
    "cancelled": "Annulé"
  },
  "kinds": {
    "location": {
      "title": "Un emplacement",
      "text": "Tous les produits d'un magasin, d'un entrepôt ou d'une zone"
    },
    "category": {
      "title": "Une catégorie",
      "text": "Par exemple seulement Électricité, dans un emplacement"
    },
    "full": {
      "title": "Tout",
      "text": "Un inventaire complet de tous les produits, partout"
    }
  },
  "scope": {
    "everything": "Tout",
    "everywhere": "tous les emplacements",
    "category": "catégorie {{name}}",
    "started": "commencé {{when}} par {{name}}",
    "prepared": "préparé {{when}} par {{name}}"
  },
  "columns": {
    "number": "Numéro",
    "scope": "Ce qui est compté",
    "when": "Quand",
    "counted": "Compté",
    "different": "Écarts",
    "status": "Statut",
    "product": "Produit",
    "expected": "Attendu",
    "difference": "Écart",
    "value": "Valeur (TND)"
  },
  "list": {
    "status": "Statut",
    "anyStatus": "Tous les statuts",
    "progress": "{{counted}} / {{total}}",
    "emptyTitle": "Aucun inventaire pour l'instant",
    "emptyText": "Commencez un inventaire pour comparer les rayons avec le système.",
    "loadMore": "Afficher plus"
  },
  "sessions": {
    "title": "Sessions d'inventaire",
    "all": "Toutes",
    "none": "Aucun inventaire pour l'instant.",
    "this": "cet inventaire"
  },
  "start": {
    "title": "Commencer un inventaire",
    "question": "Que voulez-vous compter ?",
    "dialogText": "Rien n'est gelé pour l'instant : les produits sont gelés quand vous commencez à compter.",
    "location": "Emplacement",
    "category": "Catégorie",
    "choose": "Choisir…",
    "note": "Note (facultatif)",
    "cancel": "Annuler",
    "prepare": "Préparer l'inventaire"
  },
  "draft": {
    "title": "Prêt à commencer",
    "text_one": "Au démarrage, le système note ce qu'il attend pour {{count}} produit et le gèle à {{place}} jusqu'à la validation ou l'annulation de l'inventaire.",
    "text_many": "Au démarrage, le système note ce qu'il attend pour {{count}} produits et les gèle à {{place}} jusqu'à la validation ou l'annulation de l'inventaire.",
    "text_other": "Au démarrage, le système note ce qu'il attend pour {{count}} produits et les gèle à {{place}} jusqu'à la validation ou l'annulation de l'inventaire.",
    "start": "Commencer à compter",
    "discard": "Abandonner",
    "discardTitle": "Abandonner cet inventaire ?",
    "discardText": "Rien n'a été gelé. L'inventaire garde son numéro et apparaît comme Annulé."
  },
  "detail": {
    "title": "Inventaire"
  },
  "counting": {
    "cancel": "Annuler l'inventaire",
    "finish": "Terminer et vérifier",
    "frozen_one": "{{count}} produit est gelé à {{place}}.",
    "frozen_many": "{{count}} produits sont gelés à {{place}}.",
    "frozen_other": "{{count}} produits sont gelés à {{place}}.",
    "progress": "{{counted}} sur {{total}} comptés",
    "differences_one": "{{count}} écart pour l'instant",
    "differences_many": "{{count}} écarts pour l'instant",
    "differences_other": "{{count}} écarts pour l'instant",
    "scan": "Scannez un produit, puis saisissez combien vous en voyez",
    "filter": "Afficher",
    "emptyFilter": "Rien ici.",
    "now": "En cours de comptage",
    "expects": "Le système attend",
    "counted": "comptés",
    "minus": "Un de moins",
    "plus": "Un de plus",
    "saveNext": "Enregistrer et scanner le suivant",
    "found": "{{name}} n'est pas dans cet inventaire",
    "foundText": "Le système ne l’attendait pas ici. Ajoutez-le et comptez-le : ce que vous comptez sera ce qui est en stock.",
    "where": "Où",
    "add": "Ajouter et compter",
    "notNow": "Pas maintenant",
    "noMatch": "Aucun produit ne correspond : vérifiez le code, ou tapez davantage du nom.",
    "recount": "À recompter",
    "expectedShort": "attendu {{value}}",
    "notCounted": "non compté",
    "showing": "{{shown}} affichés sur {{total}}",
    "footer": "les comptages sont enregistrés pendant la saisie · les quantités attendues négatives sont incluses pour être corrigées",
    "cancelTitle": "Annuler cet inventaire ?",
    "cancelText": "Rien ne change dans le stock. Les produits peuvent de nouveau bouger.",
    "cancelled": "Inventaire annulé",
    "frozenText_one": "Il ne peut pas y être reçu, sorti ou transféré tant que cet inventaire n'est pas validé ou annulé, pour que les chiffres restent justes.",
    "frozenText_many": "Ils ne peuvent pas y être reçus, sortis ou transférés tant que cet inventaire n'est pas validé ou annulé, pour que les chiffres restent justes.",
    "frozenText_other": "Ils ne peuvent pas y être reçus, sortis ou transférés tant que cet inventaire n'est pas validé ou annulé, pour que les chiffres restent justes.",
    "pickVariant": "{{name}} a des variantes : laquelle comptez-vous ?",
    "noVariant": "Ce produit n'a aucune variante active."
  },
  "filters": {
    "all": "Tout",
    "not_counted": "Non comptés",
    "counted": "Comptés",
    "different": "Avec écart"
  },
  "finish": {
    "title_one": "{{count}} produit n'est pas encore compté",
    "title_many": "{{count}} produits ne sont pas encore comptés",
    "title_other": "{{count}} produits ne sont pas encore comptés",
    "text": "Revenez les compter, ou comptez-les à zéro : le système les retire alors du stock à la validation.",
    "asZero": "Les compter à zéro et vérifier"
  },
  "review": {
    "title": "Vérifier l'inventaire",
    "export": "Exporter les écarts vers Excel",
    "counted": "Produits comptés",
    "nothingLeft": "Plus rien à compter",
    "left_one": "Encore {{count}} à compter",
    "left_many": "Encore {{count}} à compter",
    "left_other": "Encore {{count}} à compter",
    "matching": "Conformes",
    "matchingHint": "Compté = attendu",
    "different": "Avec écart",
    "differentHint": "{{fewer}} en moins, {{more}} en plus que prévu",
    "value": "Écart en valeur",
    "share": "{{percent}} % de la valeur attendue · seuil {{limit}} %",
    "differ": "Produits avec un écart",
    "onlyDifferences_one": "Seuls les écarts sont affichés · {{count}} produit conforme",
    "onlyDifferences_many": "Seuls les écarts sont affichés · {{count}} produits conformes",
    "onlyDifferences_other": "Seuls les écarts sont affichés · {{count}} produits conformes",
    "allMatch": "Chaque produit compté correspond à ce que le système attendait.",
    "line": "attendu {{expected}} · compté {{counted}}",
    "recount": "Recompter",
    "more_one": "+ {{count}} autre produit",
    "more_many": "+ {{count}} autres produits",
    "more_other": "+ {{count}} autres produits",
    "showAll": "Tout afficher",
    "total": "Écart total",
    "whenTitle": "À la validation",
    "when1_one": "{{count}} correction est créée pour vous, avec le motif « Correction d’inventaire ».",
    "when1_many": "{{count}} corrections sont créées pour vous, avec le motif « Correction d’inventaire ».",
    "when1_other": "{{count}} corrections sont créées pour vous, avec le motif « Correction d’inventaire ».",
    "when2": "Le stock de {{place}} devient exactement ce qui a été compté.",
    "when3_one": "Le produit est dégelé et peut de nouveau bouger.",
    "when3_many": "Les {{count}} produits sont dégelés et peuvent de nouveau bouger.",
    "when3_other": "Les {{count}} produits sont dégelés et peuvent de nouveau bouger.",
    "back": "Revenir au comptage",
    "validate": "Valider l'inventaire",
    "managerValidates": "Un responsable valide cet inventaire.",
    "done": "{{number}} validé : le stock correspond maintenant au comptage",
    "validatedBy": "Validé {{when}} par {{name}}",
    "adjustment": "Corrections écrites dans {{number}}",
    "noCorrection": "Tout correspondait : aucune correction nécessaire.",
    "cancelled": "Cet inventaire a été annulé : le stock n'a pas changé."
  }
}
